import { actionTypes } from 'actions/actionTypes'
import type { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const checkoutClearErrors: CheckoutActionCreator = () => ({
  type: actionTypes.CHECKOUT_ERRORS_CLEAR,
})
